/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './SectionHeader.scss';

import { arrayOf, object, oneOfType, string } from 'prop-types';
import React from 'react';

import { FormattedDate } from 'components/shared/Text/Text';

export const SectionHeaderWithSeparator = ({
  className = '',
  title = 'Accounts',
  fromDate,
  toDate,
  dateSeparator = 'through'
}) => {
  return (
    <div className={`section-header ${className}`}>
      <span className="section-header-title">{title}</span>
      {fromDate && toDate && (
        <span className="section-header-date">
          <FormattedDate>{fromDate}</FormattedDate> {dateSeparator}{' '}
          <FormattedDate>{toDate}</FormattedDate>
        </span>
      )}
    </div>
  );
};

SectionHeaderWithSeparator.propTypes = {
  accounts: arrayOf(object),
  title: oneOfType([string, object]),
  fromDate: string,
  toDate: string,
  dateSeparator: string
};
